/** Absolute URL builders for customer-facing share links (opaque tokens, no internal UUIDs). */

export function buildPublicHelpArticleUrl(
  publicToken: string,
  origin = window.location.origin,
): string {
  return `${origin}/help/a/${publicToken}`;
}

export function buildPublicLandingPageUrl(
  publicToken: string,
  origin = window.location.origin,
): string {
  return `${origin}/p/${publicToken}`;
}

export function buildPublicBookingWidgetUrl(
  embedToken: string,
  origin = window.location.origin,
): string {
  return `${origin}/bk/${embedToken}`;
}

export function buildPublicStayUrl(
  publicToken: string,
  origin = window.location.origin,
): string {
  return `${origin}/stay/${publicToken}`;
}
